module.exports = __webpack_public_path__ + "media/promo/panasonic/images/arrow-4ee0c70b7cb1daf7c5f22951b721e763.svg";